// extracted by mini-css-extract-plugin
module.exports = {"pillar":"Pillar_pillar__C_XDw","pillar__heading":"Pillar_pillar__heading__wqgWV"};